import { centsToDollarsWithCommas } from '@/lib/currency';
import { cn, formatNumberToAddCommas } from '@/lib/utils';
import { VehicleListing } from '@/models/registry';
import { observer } from 'mobx-react-lite';
import { type ReactNode } from 'react';
import InlineTextInput from '../ui/inline-text-input';
import { TopFeaturesInput } from './top-features/top-features-inputs';
import VehicleGallery from './vehicle-gallery';

const Row = ({ children }: { children: ReactNode }) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">{children}</div>
  );
};

const Colummn = ({
  children,
  align,
}: {
  children: ReactNode;
  align: 'start' | 'end';
}) => {
  return (
    <div
      className={cn('flex flex-row', {
        'justify-start': align === 'start',
        'lg:justify-end': align === 'end',
      })}
    >
      <div className="flex flex-col gap-2 w-full min-w-56 max-w-96">
        {children}
      </div>
    </div>
  );
};

const NonMobileMain = observer(({ listing }: { listing: VehicleListing }) => {
  return (
    <div className="flex flex-col gap-2 p-4 h-[calc(100vh-40px)] overflow-auto w-full dark:bg-dark">
      <Row>
        <Colummn align="start">
          <div className="flex flex-col gap-1">
            <a href={listing.link} target="_blank" rel="noopener noreferrer">
              <InlineTextInput
                key={`vehicle-headline-${listing.id}-ymmt`}
                placeholder="Vehicle Title"
                value={listing.YMMT}
                wrapperClassName="w-full"
                className="w-full h-fit text-black py-0 text-2xl!  tracking-tight hover:underline cursor-pointer"
                readOnly
              />
            </a>
            <div className="w-full h-fit text-gray-600 py-0 text-lg!  tracking-tight">
              {listing.vehicle?.vin}
            </div>
            <div className="w-full h-fit text-gray-600 py-0 text-lg!  tracking-tight">
              ${centsToDollarsWithCommas(listing?.price)}
            </div>
            <div className="w-full h-fit text-gray-600 py-0 text-lg!  tracking-tight">
              {formatNumberToAddCommas(listing.mileage)} miles
            </div>
            <div className="w-full h-fit text-gray-600 py-0 text-lg!  tracking-tight">
              {listing.vehicle?.exterior_color} /{' '}
              {listing.vehicle?.interior_color}
            </div>
          </div>
        </Colummn>
        <Colummn align="end">
          <div className="flex flex-row gap-2">
            <TopFeaturesInput
              id={listing.vehicle?.id ?? ''}
              value={listing.vehicle?.top_features ?? ''}
            />
          </div>
        </Colummn>
      </Row>

      <div className="h-px bg-gray-200 w-full" />
      <VehicleGallery vehicleListingID={listing.id} />
    </div>
  );
});

export default NonMobileMain;
